import { Icons, NoData } from '@cast/design-system';

type DateRangeUnsupportedBannerProps = {
  title?: string;
  body?: string;
  testId?: string;
};

export const DateRangeUnsupportedBanner = ({
  title = 'Selected date range is not supported',
  body = 'Please select a different date range to view data for this chart.',
  testId = 'date-range-unsupported-banner',
}: DateRangeUnsupportedBannerProps) => (
  <NoData
    title={title}
    body={body}
    icon={<Icons.Question weight="fill" />}
    testId={testId}
  />
);
